import classnames from 'classnames';
import Top from './components/top';
import Body from './components/body';
import styles from './PageLanding.module.scss';

function PageLanding({ setPage, loading, setLoading, className }) {
  return (
    <main className={ classnames(styles.container, className) }>
      <Top
        loading={ loading }
        setPage={ setPage }
        setLoading={ setLoading }
      />
      <Body />
    </main>
  );
}

export default PageLanding;